// Generated by robots, do not change this manually!
export var footnote1 = {
    'fontFamily': 'var(--plasma-typo-footnote1-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-footnote1-font-weight, 500)',
    'fontStyle': 'var(--plasma-typo-footnote1-font-style, normal)',
    'fontSize': 'var(--plasma-typo-footnote1-font-size, 0.875rem)',
    'letterSpacing': 'var(--plasma-typo-footnote1-letter-spacing, -0.0190em)',
    'lineHeight': 'var(--plasma-typo-footnote1-line-height, 1.125rem)'
};
//# sourceMappingURL=footnote1.js.map